module.exports = __webpack_public_path__ + "img/filter-circle.003b6b19.svg";